import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Select, Typography } from 'antd';
import { TrainingProjectsStore } from '../../stores';
import { trainingProjectFormFields, trainingProjectOptimizerTypeValues } from '../../misc/constants';

interface Props {
    store: TrainingProjectsStore;
}

const TrainingProjectOptimizerTypeSelect: React.FC<Props> = ({ store }) => {
    return (
        <>
            <Typography.Title level={5}>Optimizer Type</Typography.Title>

            <Form.Item
                name={trainingProjectFormFields.optimizerType}
                initialValue={
                    store.editableTrainingProject
                        ? store.editableTrainingProject.optimizerType
                        : trainingProjectOptimizerTypeValues.BootstrapFewShot
                }
            >
                <Select
                    placeholder="Select optimizer type"
                    options={Object.values(trainingProjectOptimizerTypeValues).map(value => ({
                        value,
                        label: value
                    }))}
                    allowClear
                />
            </Form.Item>
        </>
    );
};

export default observer(TrainingProjectOptimizerTypeSelect);
